// TASK-327 fix (judge critic, item 7): onboarding's buildProfileFromAnswers
// (onboarding-worker complete-onboarding.ts) writes these two literal strings
// into brand_profiles for a name-only brand — they pass a naive non-empty
// check but are not real business content. Kept as a small self-contained
// copy (not imported from lib/activationProgress.js, which already imports
// isBareWorkspace FROM this file — importing back would create a circular
// module dependency) so this heuristic doesn't read a placeholder-only
// description as "real content" and under-report a brand as non-bare.
const PLACEHOLDER_TEXT = new Set([
  'Business description not provided',
  'Target audience not provided',
]);

function hasText(value) {
  return typeof value === 'string' && value.trim().length > 0 && !PLACEHOLDER_TEXT.has(value.trim());
}

function hasItems(value) {
  return Array.isArray(value) && value.some(hasText);
}

// Posting still needs a brand_profile row as its per-brand data container.
// A name/language-only row is the invisible workspace created for users who
// skipped onboarding; this heuristic is intentionally client-only and does not
// change persistence or scoping semantics.
export function isBareWorkspace(brand) {
  if (!brand || typeof brand !== 'object') return false;
  const hasWebsite = hasText(brand.websiteUrl) || hasText(brand.website);
  const hasDescription = hasText(brand.businessDescription) || hasText(brand.description);
  const hasVoice = hasText(brand.customToneDescription)
    || hasText(brand.brandVoice)
    || hasText(brand.voiceDescription)
    || hasItems(brand.wordsToUse)
    || hasItems(brand.wordsToAvoid);
  return !hasWebsite && !hasDescription && !hasVoice;
}
